"use client";

import { readFragment } from "@opensea/graphql";
import { Flex, NumberDisplay, Skeleton, SpaceBetween, TextBody } from "@opensea/ui-kit";
import { ReceiptLongFilled } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useSwapCurrencies } from "../../../hooks/useSwapCurrencies";
import { SwapDetailsCollapsedItemFragment } from "./SwapDetailsCollapsedItem.fragment";
export function SwapDetailsCollapsedItem({
  swapRoute: swapRouteKey,
  collapsed
}) {
  const swapRoute = readFragment(SwapDetailsCollapsedItemFragment, swapRouteKey);
  const {
    fromAsset,
    toAsset
  } = useSwapCurrencies({
    swapRoute
  });
  const {
    control
  } = useFormContext();
  const isUsdInputMode = useWatch({
    control,
    name: "isUsdInputMode"
  });
  const totalFee = useMemo(() => {
    if (swapRoute?.__typename === "SwapRoute") {
      const {
        costs
      } = swapRoute;
      const g = costs.find(c => c.costType === "GAS")?.cost.usd ?? 0;
      const p = costs.find(c_0 => c_0.costType === "PROVIDER")?.cost.usd ?? 0;
      const m = costs.find(c_1 => c_1.costType === "MARKETPLACE")?.cost.usd ?? 0;
      return g + p + m;
    }
    return 0;
  }, [swapRoute]);
  const fromUnitValue = swapRoute?.__typename === "SwapRoute" ? swapRoute.pricePerFromAsset.token.unit : undefined;
  const toUnitValue = swapRoute?.__typename === "SwapRoute" ? swapRoute.pricePerToAsset.token.unit : undefined;
  const conversionRate = fromUnitValue && toUnitValue ? bn(toUnitValue).dividedBy(fromUnitValue) : undefined;
  const toTokensPerDollar = toAsset?.usdPrice ? bn(1).dividedBy(toAsset.usdPrice) : undefined;
  const showFee = totalFee !== 0;
  return <SpaceBetween className="w-full items-center gap-1">
      {fromAsset ? <TextBody className="font-mono" color="text-primary">
          {isUsdInputMode ? <>
              $1 ={" "}
              {toTokensPerDollar && toAsset ? <NumberDisplay display="standard" suffix={toAsset.symbol} value={toTokensPerDollar} /> : <Skeleton className="mt-0 inline-block h-3 w-[100px] align-middle" />}
            </> : <>
              <NumberDisplay suffix={fromAsset.symbol} value={1} /> ={" "}
              {toAsset && conversionRate ? <NumberDisplay display="compact" suffix={toAsset.symbol} value={conversionRate} /> : <Skeleton className="mt-0 inline-block h-3 w-[100px] align-middle" />}
            </>}
        </TextBody> : <Skeleton className="w-[200px]" />}
      {showFee && collapsed && <Flex className="gap-2">
          <ReceiptLongFilled fill="text-secondary" size={20} />
          <TextBody asChild color="text-secondary">
            <NumberDisplay display="usd" value={totalFee} />
          </TextBody>
        </Flex>}
    </SpaceBetween>;
}